module.exports = __webpack_public_path__ + "img/daping.e3314603.png";